import { render, staticRenderFns } from "./ImagesForm.vue?vue&type=template&id=becac328&scoped=true"
import script from "./ImagesForm.vue?vue&type=script&lang=js"
export * from "./ImagesForm.vue?vue&type=script&lang=js"
import style0 from "./ImagesForm.vue?vue&type=style&index=0&id=becac328&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "becac328",
  null
  
)

export default component.exports